import { FieldItemDto, ServizioDto } from "@api/client";
import AmericanExpress from "assets/images/loghi/american-express.png";
import ApplePay from "assets/images/loghi/apple-pay.svg";
import GooglePay from "assets/images/loghi/google-pay.svg";
import Maestro from "assets/images/loghi/maestro.svg";
import MasterCard from "assets/images/loghi/master-card.svg";
import PagoBancomat from "assets/images/loghi/pago-bancomat.svg";
import SamsungPay from "assets/images/loghi/samsungpay.svg";
import Visa from "assets/images/loghi/visa.svg";
import PosNumber1 from "assets/images/pos1.png";
import PosNumber2 from "assets/images/pos2.png";
import { companyDetailsSelector } from "common/_redux/company/selectors";
import { fileUpload } from "common/_redux/file/actions";
import { serviceUpdateService } from "common/_redux/service/actions";
import { serviceServiceSelector } from "common/_redux/service/selectors";
import BftBooleanButton from "common/components/boolean-button";
import BftButton from "common/components/button";
import CircuitiPagamentoCard from "common/components/circuiti-pagamento-card";
import BftDropzone from "common/components/dropzone";
import BftInfoTooltip from "common/components/info-tooltip";
import BftInput from "common/components/input";
import MessageModal from "common/components/message-modal";
import {
	DynamicValidators,
	DynamicValidatorsFields,
} from "common/validators/dynamic-validators.utils";
import { IdTipoDocumentiEstesi } from "constants/global";
import { PosImageConst } from "constants/pos-images";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { Formik } from "formik";
import { layoutStepsSelector } from "layout/_redux/selectors";
import { FileDocument } from "models/files";
import React, { useEffect, useState } from "react";
import { Col, FloatingLabel, Form, Modal, Row } from "react-bootstrap";
import InputMask from "react-input-mask";
import { useLocation, useNavigate } from "react-router-dom";

interface FormValues {
	servizioPos: string | undefined;
	servizioSpending: string | undefined;
	convenzioniPos: { [x: string]: string | boolean | string[] } | undefined;
	circuitoPagamentoPos: { [x: string]: boolean } | undefined;
	ibanAccredito: string | undefined;
	fileEstrattoConto: FileDocument | undefined;
}

const servizioSpending =
	"Consente l’accettazione dei pagamenti mediante moneta elettronica derivante dall’attività commerciale.";
const infoPos = "POS - Point Of Sale";

const Amex =
	"Per gli utenti già convenzionati con il circuito AMEX resta valida la convenzione attuale. Per i nuovi clienti si applicano altre convenzioni, clicca per leggere di più";

const SceltaPos: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const location = useLocation();

	const steps = useAppSelector(layoutStepsSelector);
	const service = useAppSelector(serviceServiceSelector);
	const companyDetails = useAppSelector(companyDetailsSelector);

	const [posSorted, setPosSorted] = useState<FieldItemDto[]>([]);
	const [pagamentoSorted, setPagamentoSorted] = useState<FieldItemDto[]>([]);
	const [initialValues, setInitialValues] = useState<FormValues>();
	const [fileEstrattoConto, setFileEstrattoConto] = useState<FileDocument | null>(null);
	const [showModal, setShowModal] = useState<boolean>(false);

	const [showModalError, setShowModalError] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	// const isDesktop = window.innerWidth <= 768;

	const handleOpenAmex = () => {
		setShowModal(true);
	};

	const handleCloseAmex = () => {
		setShowModal(false);
	};

	const getInitialValues = () => {
		let _initialValues: FormValues = {
			servizioPos: service?.servizioPos?.value || undefined,
			servizioSpending: service?.servizioSpending?.value || undefined,
			convenzioniPos: service?.convenzioniPos?.items?.reduce(
				(response: { [key: string]: string | boolean | string[] }, item) => {
					if (item?.name && item?.fieldType) {
						if (item?.fieldType == "CHECKBOX")
							response[`${item.name}_${item.fieldType}`] = item?.value == "true";
						if (item?.fieldType == "INPUT_NUMBER")
							response[`${item.name}_${item.fieldType}`] = item?.value || "";
						if (item?.fieldType == "CODICE_SERIALE") {
							const valueParse = item?.value ? JSON.parse(item?.value) : {};
							let valuesArray: string[] = [];
							Array.from({ length: Number(response[`${item.name}_INPUT_NUMBER`]) }).forEach(
								(_, index) => {
									valuesArray[index] = valueParse[index + 1];
								}
							);
							response[`${item.name}_${item.fieldType}`] = valuesArray;
						}
					}

					return response;
				},
				{}
			),
			circuitoPagamentoPos: service?.circuitoPagamentoPos?.items?.reduce(
				(response: { [key: string]: boolean }, item) => {
					if (item?.name) response[item.name] = item.value == "true";

					return response;
				},
				{}
			),
			ibanAccredito:
				service?.tipoServizio == "WEB_POS" ? service?.ibanAccredito?.value || "" : undefined,
			fileEstrattoConto:
				service?.tipoServizio == "WEB_POS" ? fileEstrattoConto || undefined : undefined,
		};

		return _initialValues;
	};

	const getValidationSchema = () => {
		let obj: DynamicValidatorsFields = {
			servizioPos: { ...service?.servizioPos },
			servizioSpending: { ...service?.servizioSpending },
			convenzioniPos: { ...service?.convenzioniPos },
			circuitoPagamentoPos: { ...service?.circuitoPagamentoPos },
			ibanAccredito: { ...service?.ibanAccredito },
			fileEstrattoConto:
				service?.tipoServizio == "WEB_POS"
					? {
							name: "fileEstrattoConto",
							visible: true,
							fieldValidationDto: {
								required: true,
							},
					  }
					: {},
		};

		if (obj.servizioPos?.fieldValidationDto)
			obj.servizioPos.fieldValidationDto = {
				...obj.servizioPos.fieldValidationDto,
				required: true,
			};

		if (obj.servizioSpending?.validation)
			obj.servizioSpending.validation = {
				...obj.servizioSpending.validation,
				when: {
					name: "servizioPos",
					value: "true",
				},
			};

		if (obj.convenzioniPos?.validation)
			obj.convenzioniPos.validation = {
				...obj.convenzioniPos.validation,
				when: {
					name: "servizioPos",
					value: "true",
				},
			};

		if (obj.circuitoPagamentoPos?.validation)
			obj.circuitoPagamentoPos.validation = {
				...obj.circuitoPagamentoPos.validation,
				when: {
					name: "servizioPos",
					value: "true",
				},
			};

		return DynamicValidators.getSchema(obj);
	};

	const handleSubmit = (values: FormValues) => {
		let files = values?.fileEstrattoConto ? [values?.fileEstrattoConto] : [];

		dispatch(fileUpload(files))
			.unwrap()
			.then((res) => {
				if (res || files?.length == 0) {
					let request: ServizioDto = {
						...service,
						servizioPos: {
							...service?.servizioPos,
							value: values?.servizioPos,
						},
						servizioSpending: {
							...service?.servizioSpending,
							...(service?.servizioSpending?.visible ? { value: values?.servizioSpending } : {}),
						},
						convenzioniPos: {
							...service?.convenzioniPos,
							items: service?.convenzioniPos?.items?.map((item) => {
								if (!item.visible) return item;

								const inputValue = values.convenzioniPos?.[`${item?.name!}_${item.fieldType}`];

								const formattedValue =
									typeof inputValue === "boolean" ? String(inputValue) : inputValue;

								const jsonFormat = Array.isArray(formattedValue)
									? `{${formattedValue.map((val, idx) => `"${idx + 1}": "${val}"`).join(", ")}}`
									: formattedValue;

								return {
									...item,
									value: jsonFormat,
								};
							}),
						},
						circuitoPagamentoPos: {
							...service?.circuitoPagamentoPos,
							items: service?.circuitoPagamentoPos?.items?.map((item) => {
								if (!item.visible) return item;

								return {
									...item,
									value: String(values.circuitoPagamentoPos?.[`${item?.name!}`]),
								};
							}),
						},

						// ibanAccredito: {
						// 	...service?.ibanAccredito,
						// 	value: values?.ibanAccredito,
						// },
					};

					dispatch(serviceUpdateService(request))
						.unwrap()
						.then((res) => {
							if (res) {
								let substeps = steps?.find(
									(s) => s.route == AppRouterService.get(PathEnum.step4)
								)?.subSteps;

								let currentStepsIndex = substeps?.findIndex((ss) => ss.route == location.pathname);

								if (currentStepsIndex == undefined) {
									console.error("No current step found");
									return;
								}

								let nextStep = substeps?.[currentStepsIndex + 1]?.route;

								if (!nextStep) {
									console.error("No next step found");
									return;
								}

								navigate(nextStep);
							}
						})
						.catch((error) => {
							setErrorMessage(error.message);
							setShowModalError(true);
						});
				}
			});
	};

	useEffect(() => {
		if (service?.convenzioniPos?.items) {
			let _pos = [...service.convenzioniPos.items];

			_pos = _pos
				.filter((x) => x.fieldType === "CODICE_SERIALE" || x.fieldType === "CHECKBOX")
				.sort((a, b) => {
					if (a?.order && b?.order) return a.order - b.order;

					return -1;
				});

			const condizionamentoPos =
				_pos.length > 0 && _pos.some((x) => x.fieldType === "CODICE_SERIALE")
					? _pos.filter((x) => x.fieldType === "CODICE_SERIALE")
					: _pos.filter((x) => x.fieldType === "CHECKBOX");

			setPosSorted(condizionamentoPos);
		}

		if (service?.circuitoPagamentoPos?.items) {
			let _pagamento = [...service.circuitoPagamentoPos.items];

			_pagamento = _pagamento.sort((a, b) => {
				if (a?.order && b?.order) return a.order - b.order;

				return -1;
			});

			setPagamentoSorted(_pagamento);
		}

		setInitialValues(getInitialValues());
	}, [service]);

	if (!initialValues) return null;

	if (service?.convenzioniPos?.items?.some((e) => e.name == null)) {
		navigate(AppRouterService.get(PathEnum.step5));
	}

	return (
		<div>
			<Formik
				initialValues={initialValues}
				onSubmit={handleSubmit}
				validationSchema={getValidationSchema}
				enableReinitialize
			>
				{({
					values,
					errors,
					touched,
					handleSubmit: _handleSubmit,
					handleChange,
					handleBlur,
					setFieldValue,
					setFieldTouched,
				}) => {
					console.log("values", values);
					const handleCustomChange = (input: keyof FormValues) => (e: any) => {
						handleChange(input)(e);

						if (input == "servizioPos" && e == "false") {
							setFieldValue(`servizioSpending`, false);
							posSorted.forEach((pos) => {
								setFieldValue(`convenzioniPos.${pos.name}_CHECKBOX`, false);
								setFieldValue(`convenzioniPos.${pos.name}_INPUT_NUMBER`, "");
							});

							pagamentoSorted.forEach((pagamento) => {
								setFieldValue(`circuitoPagamentoPos.${pagamento?.name}`, false);
							});
						}

						if (input == "servizioPos" && e == "true") {
							setFieldValue(`servizioSpending`, null);
						}

						// if (!isDesktop) {
						// 	if (input == "servizioPos" && e == null) {
						// 		setFieldValue(`servizioPos`, false);
						// 	}
						// 	if (input == "servizioSpending" && e == null) {
						// 		setFieldValue(`servizioSpending`, false);
						// 	}
						// }
					};

					const handleFileChange = (name: string, file: FileDocument | null) => {
						setFieldTouched(name);
						setFieldValue(name, file);
						setFileEstrattoConto(file);
					};

					return (
						<form
							onSubmit={(e) => {
								_handleSubmit(e);
							}}
							className="container px-4"
						>
							{service?.convenzioniPos && (
								<>
									{service?.servizioPos?.visible == true && (
										<div>
											<h5 className=" mb-3 mt-3">Scelta del POS</h5>
											<BftBooleanButton
												name="servizioPos"
												label="Desideri aggiungere il servizio POS?"
												onChange={handleCustomChange("servizioPos")}
												value={values.servizioPos}
												className="px-0"
												disabled={service?.servizioPos?.readonly === true}
											/>
											{errors.servizioPos && touched.servizioPos && (
												<Form.Control.Feedback type="invalid">
													{errors.servizioPos}
												</Form.Control.Feedback>
											)}
										</div>
									)}
								</>
							)}

							{values.servizioPos === "true" && (
								<div>
									{values.convenzioniPos && (
										<>
											{service?.servizioSpending?.visible && (
												<>
													<div className="d-flex ">
														<h5 className="mb-1 me-3">Servizio per l'incasso commerciale</h5>
														<BftInfoTooltip message={servizioSpending} />
													</div>

													<BftBooleanButton
														name="servizioSpending"
														label="Vuoi attivare l'abilitazione a questo tipo d'incasso?"
														onChange={handleCustomChange("servizioSpending")}
														className="px-0"
														value={values.servizioSpending}
														disabled={service?.servizioSpending?.readonly === true}
													/>
													{errors.servizioSpending && touched.servizioSpending && (
														<Form.Control.Feedback type="invalid">
															{errors.servizioSpending}
														</Form.Control.Feedback>
													)}
												</>
											)}

											{/* CIRCUITI DI PAGAMENTO INCLUSI */}
											<>
												{posSorted?.map(
													(e) =>
														e.fieldType === "CODICE_SERIALE" && (
															<div className="mt-3 mb-4">
																<div className="d-flex justify-content-between align-items-center">
																	<span>CONFEZIONE DEL POS</span>
																	<span>RETRO DEL POS</span>
																</div>

																<div className="d-flex justify-content-center">
																	<div className="d-flex justify-content-center align-items-center flex-column border border-5 border-primary rounded-2">
																		<img src={PosNumber1} className="w-100" />
																	</div>

																	<div className="d-flex justify-content-center align-items-center flex-column border border-5 border-primary rounded-2">
																		<img src={PosNumber2} className="w-100" />
																	</div>
																</div>
															</div>
														)
												)}

												{values.servizioPos == "true" && (
													<div>
														<h5 className="mb-3 mt-3">Seleziona il tuo POS</h5>

														<div className="bg-light rounded mt-2 px-4 py-3 d-flex flex-column">
															<span className="gray ms-0">Circuiti di pagamento inclusi:</span>
															<div className="d-flex flex-wrap">
																<CircuitiPagamentoCard image={MasterCard} className="me-3" />
																<CircuitiPagamentoCard image={Maestro} className="me-3" />
																<CircuitiPagamentoCard image={PagoBancomat} className="me-3" />
																<CircuitiPagamentoCard image={Visa} className="me-3" />
																<CircuitiPagamentoCard image={ApplePay} className="me-3" />
																<CircuitiPagamentoCard image={GooglePay} className="me-3" />
																<CircuitiPagamentoCard image={SamsungPay} className="me-3" />
															</div>
														</div>

														{posSorted?.map(
															(pos, i) =>
																pos?.visible && (
																	<Row key={i} className="bg-light rounded mt-2 p-3 mx-0">
																		<Col xs={4} md={2} className="d-flex align-items-center">
																			<Form.Check
																				type="checkbox"
																				name={`convenzioniPos.${pos.name}_CHECKBOX`}
																				checked={
																					values?.convenzioniPos?.[`${pos.name}_CHECKBOX`] ==
																						true ||
																					values?.convenzioniPos?.[`${pos.name}_CHECKBOX`] == "true"
																				}
																				onChange={(e) => {
																					handleChange(e);
																					const isChecked = e.target.checked;
																					setFieldValue(
																						`convenzioniPos.${pos.name}_CHECKBOX`,
																						isChecked
																					);
																					if (isChecked) {
																						setFieldValue(
																							`convenzioniPos.${pos.name}_INPUT_NUMBER`,
																							"1"
																						);
																					} else {
																						setFieldValue(
																							`convenzioniPos.${pos.name}_INPUT_NUMBER`,
																							"0"
																						);
																					}
																				}}
																				onBlur={handleBlur}
																			/>

																			<img
																				src={PosImageConst?.[pos?.name!]}
																				className="p-3 mx-lg-4"
																				width={80}
																			/>
																		</Col>

																		<Col xs={8} md={10} className="m-auto">
																			<Row className="g-2 align-items-center m-auto">
																				<Col sm={12} md={8} className="ps-4 pe-3">
																					{pos.fieldType !== "CODICE_SERIALE" && (
																						<div>
																							<h5>{pos?.label}</h5>
																							<p>{pos?.tooltip}</p>
																						</div>
																					)}
																					{pos.fieldType === "CODICE_SERIALE" && (
																						<div className="d-flex justify-content-around align-items-center">
																							<div>
																								<h5>{pos?.label}</h5>
																								<p>{pos?.tooltip}</p>
																							</div>

																							<div className="d-flex flex-column">
																								<div className="d-flex align-items-center">
																									<div>
																										<BftInput
																											placeholder="Numero:"
																											containerStyle={{ marginBottom: 0 }}
																											name={`convenzioniPos.${pos.name}_INPUT_NUMBER`}
																											value={
																												values?.convenzioniPos?.[
																													`${pos.name}_INPUT_NUMBER`
																												]
																											}
																											onChange={handleChange}
																											onBlur={handleBlur}
																											disabled={
																												!values?.convenzioniPos?.[
																													`${pos.name}_CHECKBOX`
																												]
																											}
																											isInvalid={
																												!!(
																													errors?.convenzioniPos?.[
																														// @ts-ignore
																														`${pos.name}_INPUT_NUMBER`
																													] &&
																													// @ts-ignore
																													touched?.convenzioniPos?.[
																														`${pos.name}_INPUT_NUMBER`!
																													]
																												)
																											}
																										/>
																									</div>
																								</div>
																							</div>
																						</div>
																					)}
																				</Col>

																				<Col sm={12} md={4} className="d-flex flex-column">
																					<div className="d-flex flex-column">
																						{pos.fieldType !== "CODICE_SERIALE" && (
																							<div className="d-flex justify-content-end align-items-center">
																								<BftInput
																									placeholder="Numero:"
																									containerStyle={{ marginBottom: 0 }}
																									name={`convenzioniPos.${pos.name}_INPUT_NUMBER`}
																									value={
																										values?.convenzioniPos?.[
																											`${pos.name}_INPUT_NUMBER`
																										]
																									}
																									onChange={handleChange}
																									onBlur={handleBlur}
																									disabled={
																										!values?.convenzioniPos?.[
																											`${pos.name}_CHECKBOX`
																										]
																									}
																									isInvalid={
																										!!(
																											errors?.convenzioniPos?.[
																												// @ts-ignore
																												`${pos.name}_INPUT_NUMBER`
																											] &&
																											// @ts-ignore
																											touched?.convenzioniPos?.[
																												`${pos.name}_INPUT_NUMBER`!
																											]
																										)
																									}
																								/>
																								<BftInfoTooltip
																									className="mb-3"
																									message={pos?.tooltip}
																								/>
																							</div>
																						)}
																					</div>

																					{Array.from({
																						length:
																							Number(
																								values?.convenzioniPos?.[`${pos.name}_INPUT_NUMBER`]
																							) || 0,
																					}).map((_, index) => (
																						<div key={index}>
																							{pos.fieldType == "CODICE_SERIALE" && (
																								<BftInput
																									placeholder="Serial-N°:"
																									containerStyle={{ marginBottom: 0 }}
																									name={`convenzioniPos.${pos.name}_CODICE_SERIALE[${index}]`}
																									value={
																										(
																											values?.convenzioniPos?.[
																												`${pos.name}_CODICE_SERIALE`
																											] as string[]
																										)?.[index]
																									}
																									onChange={handleChange}
																									onBlur={handleBlur}
																									disabled={
																										!values?.convenzioniPos?.[
																											`${pos.name}_CHECKBOX`
																										]
																									}
																									validateMaxLength
																									isInvalid={
																										!!(
																											(
																												errors?.convenzioniPos?.[
																													// @ts-ignore
																													`${pos.name}_CODICE_SERIALE`
																												] as string[]
																											)?.[index] &&
																											(
																												// @ts-ignore
																												touched?.convenzioniPos?.[
																													`${pos.name}_CODICE_SERIALE`!
																												] as string[]
																											)?.[index]
																										)
																									}
																								/>
																							)}
																						</div>
																					))}
																				</Col>
																			</Row>
																		</Col>
																	</Row>
																)
														)}

														{errors.convenzioniPos && touched.convenzioniPos && (
															<Form.Control.Feedback className="ms-3 mt-1" type="invalid">
																{errors.convenzioniPos}
															</Form.Control.Feedback>
														)}
													</div>
												)}
											</>

											{values.servizioSpending == "true" &&
												pagamentoSorted?.length > 0 &&
												companyDetails?.datiAzienda?.codiceAteco &&
												![
													"47.78.94",
													"66.19.5",
													"66.19.50",
													"92",
													"92.0",
													"92.00",
													"92.00.0",
													"92.00.01",
													"92.00.02",
													"92.00.09",
													"93.29.1",
													"93.29.10",
													"94.92",
													"94.92.0",
													"94.92.00",
												].includes(companyDetails.datiAzienda.codiceAteco) && (
													<div className="bg-light rounded mt-2 px-4 py-3 d-flex flex-column">
														{/* METODI DI PAGAMENTO AGGIUNTIVI */}
														{pagamentoSorted?.map((pagamento, i) =>
															pagamento?.visible ? (
																<div
																	key={i}
																	className="bg-light rounded d-flex align-items-center justify-content-between"
																>
																	<div>
																		<h5 className="d-flex align-items-center mb-0">
																			{pagamento?.label}
																		</h5>
																		<p className="fw-bold">
																			Abilita il terminale POS alla accettazione del circuito AMEX
																		</p>
																	</div>
																	<div className="d-flex align-items-center">
																		<Form.Check
																			type="checkbox"
																			className="me-3"
																			name={`circuitoPagamentoPos.${pagamento?.name}_CHECKBOX`}
																			checked={values.circuitoPagamentoPos?.[pagamento?.name!]}
																			onChange={(e) => {
																				const isChecked = e.target.checked;
																				setFieldValue(
																					`circuitoPagamentoPos.${pagamento?.name}`,
																					isChecked
																				);
																			}}
																			onBlur={handleBlur}
																		/>
																		<CircuitiPagamentoCard
																			image={AmericanExpress}
																			className="me-3"
																		/>
																		<BftInfoTooltip
																			onClick={handleOpenAmex}
																			message={
																				<span className="text-white">
																					Per i clienti già AMEX resta valida la convenzione
																					attuale. Per i nuovi clienti si applicano altre
																					convenzioni,{" "}
																					<i className="text-white">
																						<u className="text-primary">
																							clicca per leggere di più!
																						</u>
																					</i>
																				</span>
																			}
																		/>
																	</div>
																</div>
															) : null
														)}

														{errors.circuitoPagamentoPos && touched.circuitoPagamentoPos && (
															<Form.Control.Feedback className="ms-3" type="invalid">
																{errors.circuitoPagamentoPos}
															</Form.Control.Feedback>
														)}
													</div>
												)}

											{/* IBAN ACCREDITO */}
											{service?.tipoServizio == "WEB_POS" && (
												<>
													<div>
														<div className="d-flex align-items-center mt-4">
															<div className="container">
																<FloatingLabel
																	label="Iban su cui effettuare l'addebito*"
																	className="w-100 mb-3"
																>
																	<InputMask
																		mask={"aa 99 * 99999 99999 ************"}
																		maskChar={" "}
																		name="ibanAccredito"
																		value={values?.ibanAccredito?.toUpperCase()}
																		onChange={(e) => {
																			let event = {
																				...e,
																				currentTarget: {
																					...e.currentTarget,
																					value: e.currentTarget.value.replace(/ /g, ""),
																				},
																				target: {
																					...e.target,
																					value: e.target.value.replace(/ /g, ""),
																				},
																			};
																			handleChange("ibanAccredito")(event);
																		}}
																		onBlur={handleBlur}
																		className={`form-control ${
																			!!(errors.ibanAccredito && touched.ibanAccredito)
																				? "is-invalid"
																				: ""
																		}`}
																		// isInvalid={!!(errors.iban && touched.iban)}
																	/>
																</FloatingLabel>
															</div>

															<BftInfoTooltip message={infoPos} className="mx-lg-3 mx-0 mb-2" />
														</div>

														{errors.ibanAccredito && touched.ibanAccredito && (
															<Form.Control.Feedback className="ms-3 mb-3" type="invalid">
																{errors.ibanAccredito}
															</Form.Control.Feedback>
														)}
													</div>
													<Row>
														<Col md={6}>
															<div className="d-flex mt-4 mb-3 container d-flex justify-content-center">
																<h6>Intestazione estratto conto*</h6>
															</div>
															<BftDropzone
																label="Intestazione estratto conto*"
																idTipoDocumento={service?.hasIntEstrattoContoUplaod?.value}
																trascinaDocumento={IdTipoDocumentiEstesi?.INT_ESTRATTO_CONTO}
																file={values.fileEstrattoConto}
																onChange={(e) => handleFileChange("fileEstrattoConto", e)}
																isInvalid={
																	!!(touched.fileEstrattoConto && errors.fileEstrattoConto)
																}
															/>
															{errors.fileEstrattoConto && touched.fileEstrattoConto && (
																<Form.Control.Feedback className="ms-3 mt-1" type="invalid">
																	{errors.fileEstrattoConto}
																</Form.Control.Feedback>
															)}
														</Col>
													</Row>
												</>
											)}
										</>
									)}
								</div>
							)}

							<div className="mt-3">
								<BftButton type="submit" className="col-12 text-bg-dark border-0">
									Avanti
								</BftButton>
							</div>
						</form>
					);
				}}
			</Formik>

			<Modal show={showModalError} onHide={() => setShowModalError(false)}  centered>
				<Modal.Header closeButton>
					<Modal.Title><i className="fas fa-exclamation-triangle me-2" />Alcuni campi mancanti </Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex flex-column">
						<span>{errorMessage}</span>
					</div>
				</Modal.Body>
			</Modal>

			<MessageModal
				show={showModal}
				message={
					<div className="">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>SOGLIE* COMMISSIONALI</th>
									<th>CLASSI DI VOLUMI ANNUI</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>0.00%</td>
									<td>Fino a €3.000</td>
								</tr>
								<tr>
									<td>0.90%</td>
									<td>Oltre €3.000 e fino a €50.000</td>
								</tr>
								<tr>
									<td>1.50%</td>
									<td>Oltre €50.000 e fino a €100.000</td>
								</tr>
								<tr>
									<td>Fino ad un massimo del 4%</td>
									<td>Oltre €100.000</td>
								</tr>
							</tbody>
						</table>
						<span>
							*Le Soglie Commissionali:
							<br></br>- sono valide esclusivamente per i Nuovi Clienti American Express;
							<br></br>- si applicano ai volumi di transato American Express sviluppati
							dall’Esercente nei 12 mesi dalla data di censimento (Anno di Esercizio) a livello
							societario;
							<br></br>- sono applicate in modo proporzionale ai volumi di transato annuo nel primo
							Anno di Esercizio e successivamente secondo il principio di appartenenza alla Classe
							di Volume di cui alla tabella.
							<br></br>- non si applicano al settore Alberghiero, Petrolifero e Autonoleggio cui
							American Express si riserva il diritto di assegnare una commissione diversa e comunque
							non superiore al 4% previa comunicazione all’Esercente.
						</span>
					</div>
				}
				onClose={handleCloseAmex}
				title="Convenzioni American Express"
			/>
		</div>
	);
};
export default SceltaPos;
